import { render, staticRenderFns } from "./VehicleBreakdownList.vue?vue&type=template&id=d230d30e"
import script from "./VehicleBreakdownList.vue?vue&type=script&lang=js"
export * from "./VehicleBreakdownList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports